var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTime(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A9AEB7",
    fillRule: "nonzero",
    d: "M8.393 1.4C4.529 1.4 1.4 4.536 1.4 8.4s3.129 7 6.993 7c3.871 0 7.007-3.136 7.007-7s-3.136-7-7.007-7zM8.4 14c-3.094 0-5.6-2.506-5.6-5.6s2.506-5.6 5.6-5.6S14 5.306 14 8.4 11.494 14 8.4 14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L16.8 0 16.8 16.8 0 16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A9AEB7",
    fillRule: "nonzero",
    d: "M8.75 4.9L7.7 4.9 7.7 9.1 11.375 11.305 11.9 10.444 8.75 8.575z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTime);
export default __webpack_public_path__ + "static/media/ic-time.09e138ba.svg";
export { ForwardRef as ReactComponent };